import Modal from './Modal'
import ModalClose from './ModalClose'
import ModalContent from './ModalContent'
import ModalView from './ModalView'

export { ModalClose, ModalContent, ModalView }
export default Modal
